import { FC } from 'react';
import { cn } from '../lib';
import { InfoIcon } from 'lucide-react';
import { Typography } from './Typography';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';

interface InformationNoteProps {
  title: string;
  description?: string;
  className?: string;
  variant?: 'info' | 'warning';
}

export const InformationNote: FC<InformationNoteProps> = ({ title, description, className, variant = 'info' }) => {
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  return (
    <div
      className={cn(
        'flex flex-col rounded-lg p-2',
        variant === 'info' ? 'bg-badge-background03' : 'bg-badge-background04',
        isMinimalistic && 'rounded-none',
        className,
      )}
    >
      <div className='flex gap-3'>
        <InfoIcon
          size={16}
          className={cn(
            'flex-shrink-0',
            description && 'mt-1',
            variant === 'info' ? 'text-badge-stroke03' : 'text-badge-stroke04',
          )}
        />

        <div className='flex flex-col gap-1'>
          <Typography variant='text5' color={variant === 'info' ? 'badgeStroke03' : 'badgeStroke04'}>
            {title}
          </Typography>

          {description && (
            <Typography variant='subtitle3' color={variant === 'info' ? 'badgeStroke03' : 'badgeStroke04'}>
              {description}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
